import { AbstractControl, FormArray, FormRecord, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { RiskParamForm } from '@app/features/main/views/risks/risks-import/risks-import.component';
import { isPresent } from '@app/shared/validators/extra-validators.module';

/**
 * Verify that all the values in the list are unique
 * @param list
 */
export const distinct = (list: any[]) => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (isPresent(Validators.required(control))) return null;

    return list.includes(control.value) ? {distinct: true} : null;
  };
};

/***
 * Check if the value of each control of the array is unique
 */
export const distinctRiskFieldValueOrders = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control || !control.parent || isPresent(Validators.required(control))) {
      return null;
    }
    const fieldValue = control.value;
    const controlArray = control.parent as FormArray;
    const fieldValueOccurrence = controlArray.controls.filter(control => control.value == fieldValue).length;
    if (fieldValueOccurrence < 2) {
      controlArray.controls.filter(control => control.invalid).forEach(control => control.updateValueAndValidity());
      return null;
    } else {
      return {unique: true};
    }
  };
};

export const distinctRiskParamFields = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control || !control.parent?.parent || isPresent(Validators.required(control))) {
      return null;
    }
    const newValue = control.value?.code;
    const paramGroupFrom = control.parent.parent as FormRecord<RiskParamForm>;
    const fieldControls = Object.values(paramGroupFrom.controls).map(param => param.controls.field);
    const fieldOccurrence = fieldControls.filter(param => param.value?.code == newValue).length;
    if (fieldOccurrence < 2) {
      fieldControls.filter(control => control.invalid).forEach(control => control.updateValueAndValidity());
      return null;
    } else {
      return {distinctRiskParamFields: true};
    }
  };
};

/**
 * Check that a control's value is unique among its siblings in a FormArray.
 * Sets a `unique` error on the offending control.
 */
export const distinctFieldValue = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control?.parent || isPresent(Validators.required(control))) return null;

    const siblings = (control.parent as FormArray).controls;
    const occurrences = siblings.filter(sibling => sibling.value === control.value).length;

    if (occurrences < 2) {
      // Re-validate previously invalid siblings that may now be unique again.
      siblings.filter(sibling => sibling !== control && sibling.invalid)
        .forEach(sibling => sibling.updateValueAndValidity());
      return null;
    }
    return {unique: true};
  };
};
